import { render, staticRenderFns } from "./ManageDriverId.vue?vue&type=template&id=1bf116fd&scoped=true"
import script from "./ManageDriverId.vue?vue&type=script&lang=js"
export * from "./ManageDriverId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf116fd",
  null
  
)

export default component.exports